import { useState, useEffect, useCallback } from 'react';
import LoadingIndicator from '../components/LoadingIndicator';
import ErrorPage from '../components/ErrorPage';
import MainBanner from '../components/MainBanner';

export default function Home() {
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (!imageLoaded) {
                setHasError(true);
                setIsLoading(false);
            }
        }, 5000);

        // clear timeout
        return () => clearTimeout(timeout);

    }, [imageLoaded]);

        const handleImageLoaded = useCallback(() => {
        setImageLoaded(true);
        setIsLoading(false);
    }, []);

    if (hasError) {
        return <ErrorPage msg='Server Error' />
    }

    return (
        <div className='home-page'>
            { isLoading && <LoadingIndicator /> }

            <div style={{ display: isLoading ? 'none' : 'block' }}>
                <MainBanner onLoaded={ handleImageLoaded } /> 
            </div>
        </div>
    );
}